<template lang="pug">

.row-lessons
  .pair(v-if="!isTeachers") {{ row.lesson }}
  .time {{ row.startTime }}-{{ row.endTime }}
  .others
    .info-lesson(v-if="!lessons.length")
      .subject
      .teacher
      .cabinet

    template(v-else)
      .info-lesson(v-for="lesson in lessons")
        .subject
          .lessons-detail
            span.type-lesson(v-if="lesson.typeLesson") {{ lesson.typeLesson.name }}
            div
              .lesson-subgroup(v-if="getSubgroupsOnly(lesson) && !isTeachers") (<span class="cgray">г.</span> {{ getSubgroupsOnly(lesson)}})
              a.subject-link(v-if="lesson.subject.infoUrl" :href="lesson.subject.infoUrl" target="_blank") {{ lesson.subject.name }}
              div(v-else) {{ lesson.subject.name }}

        .teacher.teacher--column(v-if="!isTeachers")
          router-link.item-link(
            v-for="teacher of lesson.teachers"
            :key="teacher.id"
            :to="{ name: 'teachers_lessons', params: { teacherId: teacher.id }, query: { date: $route.query.date }}"
          ) {{ getTeahcersNames(teacher) }}

        .teacher.teacher--column(v-else)
          router-link.item-link(
            v-for="union of lesson.unionGroups"
            :key="union.id"
            :to="{ name: 'groups_lessons', params: { groupId: union.group.id }, query: { date: $route.query.date }}"
            v-html="groupNames(union)"
          )

        .cabinet {{ lesson.cabinet ? lesson.cabinet.name : '' }}

</template>

<script>
import { shortFio } from '@/common'

export default {
  name: 'rowLessons',

  props: {
    row: {
      type: Object,
      required: true
    },
    lessons: {
      type: Array,
      required: true,
    },
    isTeachers: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {

    }
  },

  computed: {
    groupedLessons() {
      return _(this.lessons)
        .groupBy((x) => x.startTimeMin)
        .map((lessons) => lessons)
        .orderBy((lessons) => lessons[0].startTimeMin)
        .value()
    }
  },

  methods: {
    groupNames(union) {
      let name = union.group.name

      if (union.subgroup) {
        name += ` (<span class="sugroup-name">${union.subgroup.name}</span>)`
      }

      return name
    },

    getTeahcersNames(teacher) {
      return this.fullTeacherFio ? teacher.fio : shortFio(teacher.fio)
    },

    getSubgroupsOnly(lesson) {
      return lesson.unionGroups
        .filter((x) => x.subgroup)
        .map((x) => x.subgroup.name)
        .join(', ')
    }
  }
}

</script>

<style lang="sass" scoped>

.others
  flex-direction: column

.info-lesson
  display: flex
  width: 100%
  flex: 1
  align-items: stretch

  &:not(:last-child)
    border-bottom: 1px solid #d5d5d5

.pair
  justify-content: center

.type-lesson
  flex: 0 0 auto
  color: gray
  padding-right: 5px

.lessons-detail
  display: flex

.lesson-subgroup
  font-size: 12px

.cgray
  color: gray

.subject-link,
.item-link
  text-decoration: none

  &:hover
    text-decoration: underline

.teacher--column
  display: flex !important
  flex-direction: column !important
  align-items: flex-start !important
  justify-content: center

  div
    word-break: break-word

</style>